import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import Search from 'components/SearchBox';
import pageActionStyles from './pageActionBar.scss';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';
import { can } from '../../../services';
import PageActionButton from 'components/PageActionButton';
import cx from 'classnames';

class PageActionBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { scrolling: false };
    this.toggleScrollStatus = this.toggleScrollStatus.bind(this);
  }

  componentDidMount = () => window.addEventListener('scroll', this.toggleScrollStatus, false);

  componentWillUnmount = () => window.removeEventListener('scroll', this.toggleScrollStatus, false);

  onSearch = (...args) => {
    const { onSearch } = this.props;
    if (onSearch) onSearch(...args);
  }

  toggleScrollStatus = () => (window.pageYOffset > 0 ?
    this.setState({ scrolling: true }) : this.setState({ scrolling: false }));

  renderFilterBtn = () => {
    const { showFiltersBtn, toggleFilters, userRestrictedFilters } = this.props;
    return (showFiltersBtn && !userRestrictedFilters ? (<PageActionButton
      actionText="Filter"
      actionIcon="filter_list"
      action={toggleFilters}
      actionColor="orange"
    />) : null);
  }

  renderActions = () => {
    const { role, resource, hidesAddOnMobile, showAdd, addAction,
            user: { position = '', name = '' } } = this.props;
    if (!showAdd) return null;
    const CUT = hidesAddOnMobile ? CUT_POINT : 0;
    return (can(role, 'create', resource, { position, name }) ? (<MediaQuery minWidth={CUT}>
      <PageActionButton
        actionText="Add"
        actionIcon="add"
        action={addAction}
        actionColor="blue"
      />
    </MediaQuery>) : null);
  }

  renderSearchBox = () => {
    const { searchText, searchValue, parentComponent, employableType } = this.props;
    if (
      parentComponent === 'Workrooms' &&
      ['Estimator', 'Installer', 'Crew'].includes(employableType)
    ) return null;
    return (searchText ? (<Search
      placeholder={searchText}
      onSubmit={this.onSearch}
      value={searchValue}
    />) : null);
  }

  renderChildren = (children, path) => {
    if (children) return children;
    const subPath = path.match(/(?:employees|estimators|iqms|installers)(.+)/g);
    return !(subPath && subPath.length && subPath[0].includes('/')) ? (<Fragment>
      <div className={pageActionStyles.middle}>
        {this.renderSearchBox()}
      </div>
      {this.renderActions()}
    </Fragment>) : null;
  }

  render = () => {
    const { title, banner, subTitle, children = null, path = '' } = this.props;
    return (<div
      className={cx(pageActionStyles.pageActionBarContainer, {
        [pageActionStyles.scrolling]: this.state.scrolling,
      })}
    >
      <Helmet title={title} />
      {this.renderFilterBtn()}
      <div className={pageActionStyles.title}>
        <div>
          {title} <span className={pageActionStyles.banner}>{banner}</span>
          <div className={pageActionStyles.subTitle}>{subTitle}</div>
        </div>
      </div>
      {this.renderChildren(children, path)}
    </div>);
  }
}

PageActionBar.propTypes = {
  role: PropTypes.string,
  showFiltersBtn: PropTypes.bool,
  userRestrictedFilters: PropTypes.bool,
  toggleFilters: PropTypes.func,
  resource: PropTypes.string,
  showAdd: PropTypes.bool,
  hidesAddOnMobile: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  banner: PropTypes.string,
  searchText: PropTypes.string,
  searchValue: PropTypes.string,
  addAction: PropTypes.oneOfType([
    PropTypes.func, PropTypes.string,
  ]),
  onSearch: PropTypes.func,
  children: PropTypes.node,
  user: PropTypes.object,
  path: PropTypes.string,
  parentComponent: PropTypes.string,
  employableType: PropTypes.string,
};

PageActionBar.defaultProps = {
  showAdd: true,
  hidesAddOnMobile: false,
  showFiltersBtn: true,
  userRestrictedFilters: false,
  searchText: null,
  user: {},
  path: '',
  parentComponent: '',
  employableType: '',
};

export default PageActionBar;



// WEBPACK FOOTER //
// ./client/app/shared/components/PageActionBar/index.jsx